
<div class="container">
    <div class="d-flex justify-content-center">
        <div class="row">
    
            <div class="col-sm-12">
                <label for="">รูปแบบ</label>
                <select name="" id="" class="form-control">
                    <option value="">---โปรดเลือกรูปแบบ---</option>
                    <option value="">รับสมาชิก</option>
                    <option value="">สมาชิกซื้อสินค้า100ชิ้น</option>
                    <option value="">สมาชิกเลิกซื้อสินค้า</option>
                    <option value="">สมาชิกซื้อมากสุดไปหาน้อยสุด</option>
                    <option value="">....</option>
                </select>
            </div>
    
            <br>
    
    
            <div class="col-sm-6">
                <label for="">จากวันที่</label>
                <input type="date" class="form-control">
            </div>
            <div class="col-sm-6">
                <label for="">ถึงวันที่</label>
                <input type="date" class="form-control">
            </div>
    
    
        </div>
    
    </div>
    <hr>
    <table class="table table-bordered table-inverse table-responsive">
        <thead class="thead-inverse">
            <tr>
                <th>#</th>
                <th>ลำดับที่</th>
                <th>ชื่อ-สกุล</th>
                <th>เบอร์โทร</th>
               <th>email</th>
                <th>วัน-เดือน-ปี</th>
               
            </tr>
        </thead>
        <tbody>
            <tr>
                <td scope="row"><button type="button" class="btn btn-info btn-sm"><i class="fa fa-search" aria-hidden="true"></i></button></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
    
        </tbody>
    </table>
    <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-info"><i class="fa fa-print" aria-hidden="true"></i>
            พิมพ์ข้อมูล</button>
    </div>
</div>
